<template>
  <m-content-card300 :content="item"/>
</template>

<script>
import mContentCard300 from "../../../../Content/Card/ContentCard300";

export default {
  name: "CategoryCard",
  components: {mContentCard300},
  props: ['item'],
}
</script>

<style scoped>

</style>